export const tableData = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '专家',
    },
    {
      key: 'suggest',
      dataIndex: 'suggest',
      title: '建议内容',
      slot: 'suggest',
    },
    {
      key: 'scorelabel',
      title: '建议现场核查',
      dataIndex:'scorelabel',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
